import {BASE_URL_API} from "../Const";
import * as htmlToImage from "html-to-image";
import Swal from "sweetalert2";

export class PrintUtils {

    static showLoadingDialog(message = 'لطفا صبر کنید...') {
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                title: message,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }
    }

    static getPrinters() {
        try {
            return JSON.parse(localStorage.getItem('h_printers')) || [];
        } catch {
            return [];
        }
    }

    static hideLoadingDialog() {
        if (typeof Swal !== 'undefined' && Swal.isLoading()) {
            Swal.close();
        }
    }

    static renderDiscountBlock(data) {
        if (!data.original_amount) return "";
        const original = Number(data.original_amount || 0);
        const discount = original - (parseInt(data.total));
        if (discount <= 0.001) return "";
        return `
        <div style="margin-top:4px;">
            <strong>تخفیف اعمال شده:</strong>
            <span style="color:#c00;">${discount.toLocaleString()} تومان</span>
        </div>`;
    }

    static async handleSilentPrint(orderData = {}) {
        this.showLoadingDialog('در حال تولید و ارسال فاکتور به چاپگر...');

        const list = typeof this.getPrinters === 'function' ? this.getPrinters() : [];
        const printersToPrint = list.length > 0 ? list : [{}]; // fallback
        const PAPER_WIDTH = 576;

        function gregorian_to_jalali(gy, gm, gd) {
            var g_d_m, jy, jm, jd, gy2, days;
            g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            gy2 = (gm > 2) ? (gy + 1) : gy;
            days = 355666 + (365 * gy) + ~~((gy2 + 3) / 4) - ~~((gy2 + 99) / 100) + ~~((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
            jy = -1595 + (33 * ~~(days / 12053));
            days %= 12053;
            jy += 4 * ~~(days / 1461);
            days %= 1461;
            if (days > 365) {
                jy += ~~((days - 1) / 365);
                days = (days - 1) % 365;
            }
            if (days < 186) {
                jm = 1 + ~~(days / 31);
                jd = 1 + (days % 31);
            } else {
                jm = 7 + ~~((days - 186) / 30);
                jd = 1 + ((days - 186) % 30);
            }
            return [jy, jm, jd];
        }

        function drawProductFactor(shipping, products, body) {
            const UNITS_CACHE_KEY = 'product_units_cache';
            let units = [];
            try { units = JSON.parse(localStorage.getItem(UNITS_CACHE_KEY) || '[]'); } catch (e) { units = []; }
            const unitNameById = new Map(Array.isArray(units) ? units.map(u => [String(u.id), u.name]) : []);

            const tbl = document.createElement("table");
            const tblBody = document.createElement("tbody");
            tbl.style.borderCollapse = "collapse";
            tbl.style.width = "100%";
            tbl.style.marginTop = "10px";
            tbl.style.direction = "rtl";
            tbl.className = "table table-bordered";
            tbl.setAttribute("dir", "rtl");

            const headerRow = document.createElement("tr");
            const headers = ["عنوان", "تعداد", "قیمت", "مجموع"];
            headers.forEach(header => {
                const th = document.createElement("th");
                th.textContent = header;
                th.style.padding = "8px";
                th.style.border = "1px solid #000";
                th.style.backgroundColor = "#f2f2f2";
                headerRow.appendChild(th);
            });
            tblBody.appendChild(headerRow);

            let totalCount = 0;
            let totalSum = 0;

            (Array.isArray(products) ? products : []).forEach(product => {
                const row = document.createElement("tr");
                const title = product?.title ?? "";
                const countNum = parseFloat(product?.count ?? 0);
                const safeCount = Number.isFinite(countNum) ? countNum : 0;
                const countDisplay = Number.isInteger(safeCount) ? String(safeCount) : Number(safeCount.toFixed(4)).toString();

                const priceNum = parseFloat(product?.price ?? 0);
                const delNum = parseFloat(product?.del_price ?? 0);
                const unitPrice = (Number.isFinite(priceNum) ? priceNum : 0) - (Number.isFinite(delNum) ? delNum : 0);

                const unitId = product?.unit_id ?? null;
                const unitName = unitId != null ? (unitNameById.get(String(unitId)) || "") : "";

                const rowTotal = unitPrice * safeCount;
                totalCount += safeCount;
                totalSum += rowTotal;

                const titleCell = document.createElement("td");
                titleCell.textContent = title;
                titleCell.style.border = "1px solid #000";
                titleCell.style.padding = "6px";
                row.appendChild(titleCell);

                const countCell = document.createElement("td");
                countCell.textContent = `${countDisplay} ${unitName}`.trim();
                countCell.style.border = "1px solid #000";
                countCell.style.padding = "6px";
                row.appendChild(countCell);

                const priceCell = document.createElement("td");
                priceCell.textContent = (Number(unitPrice) || 0).toLocaleString() + " تومان";
                priceCell.style.border = "1px solid #000";
                priceCell.style.padding = "6px";
                row.appendChild(priceCell);

                const totalCell = document.createElement("td");
                totalCell.textContent = (Number(rowTotal) || 0).toLocaleString() + " تومان";
                totalCell.style.border = "1px solid #000";
                totalCell.style.padding = "6px";
                row.appendChild(totalCell);

                tblBody.appendChild(row);
            });

            const footerRow = document.createElement("tr");
            const footerTitle = document.createElement("td");
            footerTitle.textContent = "جمع کل";
            footerTitle.style.border = "1px solid #000";
            footerTitle.style.padding = "8px";
            footerTitle.style.fontWeight = "bold";
            footerRow.appendChild(footerTitle);

            const footerCount = document.createElement("td");
            const footerCountDisplay = Number.isInteger(totalCount) ? totalCount.toString() : Number(totalCount.toFixed(4)).toString();
            const uniqueProductCount = Array.isArray(products) ? products.length : 0;
            footerCount.textContent = `${footerCountDisplay} (${uniqueProductCount} قلم)`;
            footerCount.style.border = "1px solid #000";
            footerCount.style.padding = "8px";
            footerRow.appendChild(footerCount);

            const footerUnitPrice = document.createElement("td");
            footerUnitPrice.textContent = "-";
            footerUnitPrice.style.border = "1px solid #000";
            footerUnitPrice.style.padding = "8px";
            footerRow.appendChild(footerUnitPrice);

            const footerTotal = document.createElement("td");
            const ship = parseFloat(shipping || 0) || 0;
            footerTotal.textContent = (totalSum + ship).toLocaleString() + " تومان";
            footerTotal.style.border = "1px solid #000";
            footerTotal.style.padding = "8px";
            footerRow.appendChild(footerTotal);

            tblBody.appendChild(footerRow);
            tbl.appendChild(tblBody);
            body.appendChild(tbl);
        }

        function renderSellerDescription(body) {
            const GLOBAL_DESC_KEY = 'h_global_factor_description';
            const globalDesc = localStorage.getItem(GLOBAL_DESC_KEY);

            if (globalDesc && String(globalDesc).trim() !== '') {
                const globalDescBox = document.createElement('div');
                globalDescBox.style.fontSize = '12px';
                globalDescBox.style.textAlign = 'right';
                globalDescBox.style.direction = 'rtl';
                globalDescBox.style.color = '#000000';
                globalDescBox.innerHTML = `
                <div style="border-top:1px dashed #999; margin-top:4px;">
                    <div style="line-height:1.8; white-space: pre-wrap; word-break: break-word; font-family: inherit;">${globalDesc}</div>
                </div>
                `;
                body.appendChild(globalDescBox);
            }
        }

        const PRINTER_PROFILES = {
            hilpos: 576, bixolon: 520, beiyang: 512, axiom: 512, meva: 520
        };

        function resolvePrintableWidth(pTarget = {}) {
            const w = Number(pTarget.width);
            if (Number.isFinite(w)) return w;
            const name = (pTarget.name || '').toLowerCase();
            const ip = (pTarget.ip || '').toLowerCase();
            if (/hilpos|tt200|hilpos80/.test(name)) return PRINTER_PROFILES.hilpos;
            if (/bixolon|srp/.test(name)) return PRINTER_PROFILES.bixolon;
            if (/beiyang|u80/.test(name)) return PRINTER_PROFILES.beiyang;
            if (/axiom|l8/.test(name)) return PRINTER_PROFILES.axiom;
            if (/meva|mv/.test(name)) return PRINTER_PROFILES.meva;
            if (ip.endsWith('.251')) return PRINTER_PROFILES.beiyang;
            if (ip.endsWith('.240')) return PRINTER_PROFILES.bixolon;
            return PAPER_WIDTH;
        }

        // اطلاعات مشترک (زمان)
        const createdAtData = orderData?.created_at || orderData?.order?.created_at || new Date();
        const createdAt = new Date(createdAtData);
        const timePart = createdAt.toTimeString().split(' ')[0];
        const datePart = createdAt.toISOString().split('T')[0];
        const [year, month, day] = datePart.split('-').map(Number);
        const jDate = gregorian_to_jalali(year, month, day).join('/');

        // به جای یک بار تولید، برای هر پرینتر یک‌بار DOM را بر اساس تنظیمات آن (is_summerize) می‌سازیم
        for (const p of printersToPrint) {
            let sandbox = null;
            try {
                const targetIp = p.ip || '127.0.0.1';
                const targetPort = Number(p.port) || 9100;
                const PRINT_SERVER = p.shared_printer_ip ? `https://${p.shared_printer_ip}:9092` : `http://127.0.0.1:9091`;

                const isSummarize = !!p.is_summerize; // <--- تشخیص حالت از تنظیمات پرینتر فعلی
                const printableWidth = resolvePrintableWidth(p); // <--- محاسبه عرض پرینتر فعلی

                const container = document.createElement('div');

                if (isSummarize) {
                    // ======================================
                    // حالت خلاصه (سفارش داخلی)
                    // ======================================
                    Object.assign(container.style, {
                        width: printableWidth + 'px', margin: '0', padding: '0', background: '#fff', color: '#000', direction: 'rtl', fontSize: '26px', lineHeight: '2.2', fontWeight: '600', fontFamily: 'Tahoma, sans-serif'
                    });

                    const headerBox = document.createElement('div');
                    headerBox.style.border = '3px solid #000';
                    headerBox.style.padding = '12px';
                    headerBox.style.marginBottom = '18px';
                    headerBox.style.fontSize = '26px';
                    headerBox.style.fontWeight = 'bold';

                    const orderId = orderData?.id ?? '—';
                    const factorNumber = orderData?.factor_number;
                    const operatorName = localStorage.getItem('operator_name') || '';

                    let factorDisplayHtml = `<div>شماره: ${orderId}</div>`;
                    if (factorNumber && factorNumber != orderId) {
                        factorDisplayHtml = `
                        <div style="text-align: right;">
                            <span style="display: inline-block; border: 1px solid black; padding: 2px 6px; margin-bottom: 4px; font-size: 1.3em; font-weight: bold; border-radius: 3px;">${factorNumber}</span><br>
                            <div>شماره پیگیری: ${orderId}</div>
                        </div>`;
                    }

                    headerBox.innerHTML = `
                        <div style="display:flex; justify-content:space-between; align-items: flex-end;">
                            ${factorDisplayHtml}
                            <div>تاریخ: ${jDate}</div>
                        </div>
                        <div style="margin-top:6px; display:flex; justify-content:space-between;">
                            <div>ساعت: ${timePart}</div>
                            ${operatorName ? `<div>صندوق: ${operatorName}</div>` : `<div></div>`}
                        </div>
                    `;
                    container.appendChild(headerBox);

                    const title = document.createElement('div');
                    const marketName = localStorage.getItem('market_name') || '';
                    title.innerHTML = `
                        <div style="font-size:30px;font-weight:bold;">سفارش داخلی</div>
                        ${marketName ? `<div style="font-size:26px;margin-top:6px;">${marketName}</div>` : ''}
                    `;
                    title.style.textAlign = 'center';
                    title.style.marginBottom = '16px';
                    title.style.fontSize = '30px';
                    title.style.fontWeight = 'bold';
                    container.appendChild(title);

                    const table = document.createElement('table');
                    table.style.width = '100%';
                    table.style.borderCollapse = 'collapse';
                    table.style.tableLayout = 'fixed';
                    table.style.border = '3px solid #000';

                    const thead = document.createElement('thead');
                    const headerRow = document.createElement('tr');
                    const thTitle = document.createElement('th');
                    thTitle.textContent = 'عنوان';
                    Object.assign(thTitle.style, { border: '3px solid #000', padding: '10px 6px', textAlign: 'right', fontSize: '26px', fontWeight: 'bold' });
                    const thCount = document.createElement('th');
                    thCount.textContent = 'تعداد';
                    Object.assign(thCount.style, { border: '3px solid #000', padding: '10px 6px', width: '120px', textAlign: 'center', fontSize: '26px', fontWeight: 'bold' });

                    headerRow.appendChild(thTitle);
                    headerRow.appendChild(thCount);
                    thead.appendChild(headerRow);
                    table.appendChild(thead);

                    const tbody = document.createElement('tbody');
                    const items = Array.isArray(orderData?.meta_orders) ? orderData.meta_orders : [];

                    items.forEach(item => {
                        const pTitle = item?.product?.title ?? item?.product_title ?? item?.title ?? '—';
                        const vTitle = item?.variant?.title ?? item?.variant_title ?? null;
                        let finalTitle = pTitle;
                        if (vTitle && vTitle.trim() !== '') finalTitle += ` - ${vTitle}`;
                        if (item?.label && String(item.label).trim() !== '') finalTitle += ` (${item.label})`;
                        const count = parseFloat(item?.count ?? 0) || 0;

                        const tr = document.createElement('tr');
                        const tdTitle = document.createElement('td');
                        tdTitle.textContent = finalTitle;
                        Object.assign(tdTitle.style, { border: '2px solid #000', padding: '12px 8px', wordBreak: 'break-word', fontSize: '26px', fontWeight: '600' });

                        const tdCount = document.createElement('td');
                        tdCount.textContent = count;
                        Object.assign(tdCount.style, { border: '2px solid #000', padding: '12px 8px', textAlign: 'center', fontSize: '32px', fontWeight: 'bold' });

                        tr.appendChild(tdTitle);
                        tr.appendChild(tdCount);
                        tbody.appendChild(tr);
                    });
                    table.appendChild(tbody);
                    container.appendChild(table);

                    const descriptionText = orderData?.description || '';
                    if (descriptionText && String(descriptionText).trim() !== '') {
                        const descBox = document.createElement('div');
                        Object.assign(descBox.style, { border: '3px solid #000', padding: '12px', marginTop: '18px', fontSize: '24px', lineHeight: '2', fontWeight: '600' });
                        descBox.innerHTML = `
                            <div style="margin-bottom:6px;font-weight:bold;">توضیحات:</div>
                            <div style="word-break:break-word;">${descriptionText}</div>
                        `;
                        container.appendChild(descBox);
                    }
                } else {
                    // ======================================
                    // فاکتور کامل اصلی (نرمال)
                    // ======================================
                    Object.assign(container.style, {
                        width: printableWidth + 'px', background: '#fff', color: '#000', direction: 'rtl', fontFamily: 'Tahoma, sans-serif', fontSize: '20px', lineHeight: '1.6', boxSizing: 'border-box', padding: '10px'
                    });

                    const marketId = orderData.market_id;
                    let marketInfoHTML = "";
                    if (marketId) {
                        try {
                            const response = await fetch(BASE_URL_API+`market/${marketId}`, {
                                method: 'GET', headers: { Authorization: "Bearer " + localStorage.getItem("pwa_token"), "Content-Type": "application/json", "Accept": "application/json" }
                            });
                            const result = await response.json();
                            if (result?.code === 200) {
                                const m = result.data;
                                const phone = m.tell || m.user?.phone || "";
                                const address = m.address || "بدون آدرس";
                                const slug = m.slug ? `/${m.slug}` : "";
                                const avatarUrl = m.pictures?.[0]?.url ? `/upload/images/markets/${m.pictures[0].url}` : "";
                                const operatorName =  localStorage.getItem('operator_name');
                                const avatarHtml = avatarUrl ? `<img src="${avatarUrl}" alt="لوگو" style="width:60px;height:60px;border-radius:50%;object-fit:cover;margin-bottom:10px;" />` : "";
                                marketInfoHTML = `
                                <div style="text-align:right;font-size:18px;line-height:1.6;margin-bottom:12px;">
                                <div style="float:left;">${avatarHtml}</div>
                                <strong>پذیرنده:</strong> ${m.name || ''}<br>
                                ${slug ? `<strong>سایت:</strong> ${slug}<br>` : ``}
                                ${phone ? `<strong>تلفن:</strong> ${phone}<br>` : ``}
                                <strong>آدرس:</strong> ${address}
                                ${operatorName ? `<br><strong>صندوق:</strong> ${operatorName}` : ``}
                                </div>
                                <div style="clear:both;"></div>
                                <hr style="border-top:1px solid #000; margin:10px 0;">`;
                            }
                        } catch (error) { console.warn("Market info fetch error:", error); }
                    }
                    container.insertAdjacentHTML("beforeend", marketInfoHTML);

                    let factorNumberHtml = `<p style="color:black; margin:0;">شماره: ${orderData?.id ?? '—'}</p>`;
                    if (orderData?.factor_number && orderData.factor_number != orderData.id) {
                        factorNumberHtml = `
                        <p style="color:black; margin:0; text-align:left;">
                            <span style="display: inline-block; border: 1px solid black; padding: 4px 8px; margin-bottom: 6px; font-size: 1.1em; font-weight: bold;"> شماره:${orderData.factor_number}</span><br>
                            شماره پیگیری: ${orderData?.id ?? '—'}
                        </p>`;
                    }

                    container.insertAdjacentHTML("beforeend", `
                    <div style="display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:10px; font-size: 18px;">
                        <p style="color:black; margin:0;">تاریخ: ${timePart} ${jDate}</p>
                        ${factorNumberHtml}
                    </div>`);

                    const productsArray = (Array.isArray(orderData?.meta_orders) ? orderData.meta_orders : []).map(m => {
                        let pTitle = m?.product?.title || m?.product_title || m?.title || '—';
                        let vTitle = m?.variant?.title || m?.variant_title || null;
                        let finalTitle = vTitle ? `${pTitle} - ${vTitle}` : pTitle;
                        if (m?.label) finalTitle += ` (${m.label})`;
                        return { ...m, title: finalTitle, count: m?.count || 0, price: m?.price_at_sale || m?.price || 0 };
                    });

                    const shippingCost = Number(orderData?.shipping_cost || orderData?.send_price || 0);
                    drawProductFactor(shippingCost, productsArray, container);

                    if (orderData?.description && String(orderData.description).trim() !== "") {
                        container.insertAdjacentHTML("beforeend", `
                        <div style="margin-top:8px; font-size:16px; text-align:right;">
                            <div style="border-top:1px dashed #000; padding-top:6px; margin-top:4px;">
                                <strong>توضیحات:</strong> <span>${orderData.description}</span>
                            </div>
                        </div>`);
                    }

                    const allDebts = (orderData?.meta && Array.isArray(orderData.meta.debts)) ? orderData.meta.debts : [];
                    if (allDebts.length) {
                        const totalPrevDebt = allDebts.reduce((sum, d) => sum + (Number(d?.amount) || 0), 0);
                        if (totalPrevDebt > 0) {
                            container.insertAdjacentHTML("beforeend", `
                            <div style="margin-top:4px; font-size:16px; text-align:right;">
                                <div style="border-top:1px dashed #000; padding-top:4px; margin-top:2px;">
                                    <strong>مانده بدهی‌های قبلی:</strong> <span>${totalPrevDebt.toLocaleString()} تومان</span>
                                </div>
                            </div>`);
                        }
                    }

                    const vas = Number(orderData?.vas || 0) || 0;
                    const shipping = Number(orderData?.shipping_cost || 0) || 0;
                    const totalBase = Number(orderData?.total || 0) || 0;
                    const totalPay = totalBase + shipping;
                    let discountHtml = typeof this.renderDiscountBlock === 'function' ? this.renderDiscountBlock(orderData) : '';

                    container.insertAdjacentHTML("beforeend", `
                    <div style="text-align:right; font-size:18px; margin-top:10px;">
                        <div style="border:1px dashed #000; padding:8px; border-radius:6px; background:#fff;">
                            <div style="display:flex; flex-direction:column; gap:6px;">
                                ${vas > 0 ? `<div><strong>ارزش افزوده:</strong> ${vas.toLocaleString()} تومان</div>` : ``}
                                ${shipping > 0 ? `<div><strong>هزینه ارسال:</strong> ${shipping.toLocaleString()} تومان</div>` : ``}
                                <div style="font-size:20px;"><strong>مبلغ قابل پرداخت:</strong> ${totalPay.toLocaleString()} تومان</div>
                                ${discountHtml}
                            </div>
                        </div>
                    </div>`);

                    if (orderData?.transaction?.payments?.length) {
                        let paymentsHtml = `<h5 style="margin-top:15px; margin-bottom:10px; font-size:18px;">روش‌های پرداخت:</h5><div style="display:flex; flex-wrap:wrap; gap:12px;">`;
                        const translateType = t => t === 'cash' ? 'نقد' : t === 'pos' ? 'پوز' : t === 'debt' ? 'بدهی' : t === 'cheque' ? 'چک' : t === 'discount' ? 'اعتبار' : t === 'vas' ? 'ارزش افزوده' : 'نقد';
                        for (const pay of orderData.transaction.payments) {
                            let dateHtml = '';
                            if (pay.meta && pay.meta.created_at && String(pay.meta.created_at).trim() !== '' && !isNaN(new Date(pay.meta.created_at).getTime())) {
                                const cDate = new Date(pay.meta.created_at);
                                const [y, m, d] = cDate.toISOString().split('T')[0].split('-').map(Number);
                                const pjDate = gregorian_to_jalali(y, m, d).join('/');
                                dateHtml = `<span style="font-size:14px; color:#555; margin-right:6px;">(${pjDate})</span>`;
                            }
                            paymentsHtml += `
                            <div style="border:1px solid #000; padding:8px; border-radius:6px; font-size:16px; flex:1; min-width:180px;">
                                <strong>${translateType(pay.type)}</strong>${dateHtml} - مبلغ: ${(+pay.amount || 0).toLocaleString()} تومان
                            </div>`;
                        }
                        paymentsHtml += `</div>`;
                        container.insertAdjacentHTML("beforeend", paymentsHtml);
                    }

                    const buyerInfo = orderData?.buyer || orderData?.customer || {};
                    const buyerName = buyerInfo?.name || buyerInfo?.phone_book?.name || 'مشتری عمومی';
                    const phoneBookHtml = buyerInfo.phone_book ? `
                    <p style="margin:0;"><b>نام سیستمی:</b> ${buyerName || '—'}</p>
                    <p style="margin:0;"><b>شماره تماس سیستمی:</b> ${buyerInfo.phone || '—'}</p>
                    <p style="margin:0; word-break:break-word;"><b>آدرس سیستمی:</b> ${buyerInfo.phone_book.address || '—'}</p>
                    <p style="margin:0;"><b>کد ملی:</b> ${buyerInfo.phone_book.national_code || '—'}</p>
                    ` : `<p style="margin:0; color:#555;">دفترچه موجود نیست</p>`;

                    container.insertAdjacentHTML("beforeend", `
                    <div style="margin-top:20px; font-size:16px;">
                    <hr style="border-top:1px solid #000; margin-bottom:10px;"/>
                    <div style="display:flex; gap:15px; text-align:right; align-items:flex-start;">
                        <div style="flex:1; border-right:1px solid #000; padding-right:10px; min-width:0;">
                        ${phoneBookHtml}
                        </div>
                        <div style="flex:1; padding-right:10px; min-width:0;">
                        <p style="margin:0;"><b>نام مشتری:</b> ${buyerName || '—'}</p>
                        <p style="margin:0;"><b>شماره تماس:</b> ${buyerInfo.phone || '—'}</p>
                        <p style="margin:0; word-break:break-word;"><b>آدرس:</b> ${buyerInfo.address || '—'}</p>
                        <p style="margin:0;"><b>کد پستی:</b> ${buyerInfo.postalcode || '—'}</p>
                        </div>
                    </div>
                    </div>`);

                    renderSellerDescription(container);

                    const thanks = document.createElement('div');
                    thanks.style.textAlign = 'center';
                    thanks.style.marginTop = '20px';
                    thanks.style.fontSize = '18px';
                    thanks.style.fontWeight = 'bold';
                    thanks.innerText = 'از خرید شما متشکریم';
                    container.appendChild(thanks);
                }

                // آماده سازی wrapper برای htmlToImage
                const wrap = document.createElement('div');
                Object.assign(wrap.style, {
                    width: PAPER_WIDTH + 'px', boxSizing: 'border-box', background: '#fff',
                    paddingLeft: Math.max(0, Math.floor((PAPER_WIDTH - printableWidth) / 2)) + 'px',
                    paddingRight: Math.max(0, Math.ceil((PAPER_WIDTH - printableWidth) / 2)) + 'px'
                });
                wrap.appendChild(container);

                sandbox = document.createElement('div');
                Object.assign(sandbox.style, {
                    position: 'fixed', left: '-9999px', top: '0', opacity: '0', pointerEvents: 'none', zIndex: '-1', background: '#fff'
                });
                sandbox.appendChild(wrap);
                document.body.appendChild(sandbox);

                try {
                    if (document.fonts?.ready) {
                        await Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 800))]);
                    }
                } catch {}
                await new Promise(r => setTimeout(r, 120));

                const dataUrl = await htmlToImage.toPng(wrap, {
                    width: PAPER_WIDTH, pixelRatio: 4, backgroundColor: '#fff', cacheBust: true, skipFonts: false, preferCanvas: true
                });

                if (!dataUrl || dataUrl.length < 2000) {
                    throw new Error('Generated image is empty');
                }

                // ارسال به سرور پرینت
                const res = await fetch(`${PRINT_SERVER}/print-image`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        pngBase64: dataUrl.split(',')[1],
                        width: PAPER_WIDTH,
                        threshold: 210,
                        invert: false,
                        printer_ip: targetIp,
                        printer_port: targetPort,
                    })
                });

                const json = await res.json().catch(() => ({}));
                if (!res.ok || !json.ok) {
                    console.warn(`Print failed for ${targetIp}:`, json.error || `HTTP ${res.status}`);
                } else {
                    console.log(`✅ Silent print success for ${targetIp}`);
                }

            } catch (err) {
                console.error(`[handleSilentPrint] Error for printer ${p.ip || 'unknown'}:`, err);
                Swal.fire('خطا', `خطا در تولید و چاپ فاکتور برای ${p.name || p.ip || 'چاپگر'}:\n${err?.message || ''}`, 'error');
            } finally {
                if (sandbox && sandbox.parentNode) {
                    sandbox.parentNode.removeChild(sandbox);
                }
            }
        } // پایان حلقه چاپگرها

        this.hideLoadingDialog();
    }
}
